import { Link, useForm } from "@inertiajs/react";
import { FormEvent, useContext, useState } from "react";
import { BsCheck } from "react-icons/bs";

import SimpleButton from "@/components/Buttons/SimpleButton";
import { StatusType } from "@/components/Buttons/SimpleButton/types";
import TextFieldComponent from "@/components/TextField";
import Typography from "@/components/Typography";
import { AlertContext } from "@/contexts/Alert";

import { Access, Container, Form, Img, Infos, PasswordInfos } from "./styles";

export default function SignIn() {
  const { showAlert } = useContext<any>(AlertContext);
  const [buttonStatus, setButtonStatus] = useState<StatusType>("enable");

  const { data, setData, post } = useForm({
    email: "",
    password: "",
    remember: false,
  });

  const submitUserData = (e: FormEvent) => {
    e.preventDefault();
    setButtonStatus("loading");
    post("/new_users/login", {
      onFinish: () => {
        setData("password", "");
        setButtonStatus("enable");
      },
      onSuccess: () => {
        showAlert({
          message: "Login efetuado com sucesso",
          type: "success",
        });
      },
      onError: (e) => {
        showAlert({
          message: e,
          type: "error",
        });
      },
    });
  };

  return (
    <Container>
      <div className="grid h-full grid-cols-1 justify-between gap-2 lg:grid-cols-2">
        <Infos className="col-span-1 grid grid-cols-1">
          <div className="flex flex-col items-center justify-center">
            <div className="mx-auto px-12">
              <img src="/geedee.svg" alt="logo" className="h-20 w-52" />
            </div>
            <Access className="col-span-2 mx-auto max-w-md pt-8">
              <Form onSubmit={submitUserData} className="w-full">
                <div className="mx-auto flex flex-col pb-10">
                  <Typography variant="h3" color="grey800" className="mx-auto">
                    Acessar
                  </Typography>
                  <Typography variant="pLarge" color="grey500" className="mx-auto">
                    Acesse sua conta de luz Geedee.
                  </Typography>
                </div>
                <div className="forms-input">
                  <div className="input">
                    <TextFieldComponent
                      disabled={false}
                      label="Seu e-mail"
                      error={false}
                      required
                      type="email"
                      value={data.email}
                      onChange={(e) => setData("email", e.target.value)}
                    />
                  </div>
                  <div className="input">
                    <TextFieldComponent
                      disabled={false}
                      label="Sua senha"
                      error={false}
                      password={true}
                      value={data.password}
                      required
                      onChange={(e) => setData("password", e.target.value)}
                    />
                  </div>
                </div>
                <PasswordInfos className="pb-8">
                  <div className="checkbox">
                    <label className="container">
                      <input
                        type="checkbox"
                        value={data.remember.toString()}
                        onChange={(e) => setData("remember", e.target.checked)}
                      />
                      <span>
                        <BsCheck />
                      </span>
                    </label>
                    <Typography variant="pLarge" color="grey700">
                      Lembrar senha
                    </Typography>
                    <div className="remember-password">
                      <Typography variant="link" color="black">
                        <Link href={`/new_users/password/new`}> Esqueci minha Senha </Link>
                      </Typography>
                    </div>
                  </div>
                </PasswordInfos>

                <SimpleButton variant="cta" status={buttonStatus} label="Acessar Geedee" />
              </Form>
              {/*<SignUp>*/}
              {/*  <Typography variant="pLarge" color="grey800">*/}
              {/*    Não possui conta?*/}
              {/*  </Typography>*/}
              {/*  <div className="signup-page">*/}
              {/*    <Typography variant="link" color="black">*/}
              {/*      Cadastre-se*/}
              {/*    </Typography>*/}
              {/*    <FiArrowRight className="icon" />*/}
              {/*  </div>*/}
              {/*</SignUp>*/}
            </Access>
          </div>
        </Infos>
        <Img className="invisible w-full lg:visible">
          <div className="image w-full" />
        </Img>
      </div>
    </Container>
  );
}
